import type { ComponentType } from 'react';
import {
  ArrowClockwise,
  ArrowsIn,
  ArrowsOut,
  Check,
  ClipboardText,
  DownloadSimple,
  FileAudio,
  FileCsv,
  FileDoc,
  FileImage,
  FilePdf,
  FileText,
  FileVideo,
  FileXls,
  FileZip,
  File as FileGeneric,
  Gear,
  Info,
  Keyboard,
  List,
  Pause,
  Play,
  SpeakerHigh,
  SpeakerSlash,
  Trash,
  Warning,
  WifiSlash,
  X,
  DeviceMobile,
  CaretDown,
  ArrowSquareOut,
  Lock,
} from '@phosphor-icons/react';
import type { MediaKind } from '../../core/types';

export {
  ArrowClockwise,
  ArrowsIn,
  ArrowsOut,
  Check,
  ClipboardText,
  DownloadSimple,
  Gear,
  Info,
  Keyboard,
  List,
  Pause,
  Play,
  SpeakerHigh,
  SpeakerSlash,
  Trash,
  Warning,
  WifiSlash,
  X,
  DeviceMobile,
  CaretDown,
  ArrowSquareOut,
  Lock,
};

type IconC = ComponentType<{ className?: string; 'aria-hidden'?: boolean | 'true' }>;

const BY_KIND: Record<MediaKind, IconC> = {
  video: FileVideo,
  audio: FileAudio,
  image: FileImage,
  pdf: FilePdf,
  text: FileText,
  markdown: FileText,
  json: FileText,
  csv: FileCsv,
  xml: FileText,
  docx: FileDoc,
  xlsx: FileXls,
  archive: FileZip,
  unknown: FileGeneric,
};

export function KindIcon({ kind, className }: { kind: MediaKind; className?: string }) {
  const Cmp = BY_KIND[kind];
  return <Cmp className={className} aria-hidden="true" />;
}
